import { render } from "./BookingSummary.vue?vue&type=template&id=67ed76cc"
import script from "./BookingSummary.vue?vue&type=script&lang=js"
export * from "./BookingSummary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev-intelij\\MC-production\\widget-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__